import React from "react";
import styled from "styled-components";
import Category from "./category";

export const IntegrationsContent = ({ type, data }) => {
  return (
    <ContentBase>
      { type === "amazon" && <AmazonContent data={data}/> }
      { type === "venmo" && <VenmoContent data={data}/> }
      { !type && <Placeholder><NoIntegrationsText/></Placeholder> }
    </ContentBase>
  )
}

const AmazonContent = ({ data }) => {
  return (
    <>
      {data.map((item, index) => {
        return (
          <span key={`amazon-${index}`}>
            <Category asHeader label={item.category.name} color={item.category.color} emoji={item.category.emoji} />
            <PurchaseRow>
              <Product>
                <span>{item.quantity}</span>
                <span>{item.product}</span>
              </Product>
              <Price>{item.price}</Price>
            </PurchaseRow>
          </span>
        )
      })}
    </>
  )
}

const VenmoContent = ({ data }) => {
  return (
    <>
      {data.map((item, index) => {
        return (
          <VenmoRow role="list" key={`venmo-${index}`}>
            <Label className={ item.emoji_only_description && "large" }>{item.description}</Label>
            <Category label={item.category.name} emoji={item.category.emoji} color={item.category.color} />
            <Price>{item.amount}</Price>
          </VenmoRow>
        )
      })}
    </>
  )
}

export const TransactionRuleContent = ({ data }) => {
  return (
    <ContentBase>
      {data.map((item, index) => {
        return (
            <TransactionRow role="list" key={`rule-${index}`}>
                <Label>"{item.rule}"<Dots aria-hidden="true" color={item.category.color} /></Label>
                <Category label={item.category.name} emoji={item.category.emoji} color={item.category.color} />
            </TransactionRow>
        )
      })}
    </ContentBase>
  )
}

export const SpendingContent = ({ data }) => {
  const budgetingDisabled = data.budgeting_disabled;
  return (
    <ContentBase padding="0">
      <Marker>{budgetingDisabled ? "Last Month" : "Target"}</Marker>
      {data.categories.map((item, index) => {
        return (
          <Category 
            label={item.name} 
            emoji={item.emoji} 
            color={item.color} 
            performance={item.performance}
            animDelay={index*0.08}
            key={`spend-${index}`}
          />
        )
      })}
    </ContentBase>
  )
}

export const BudgetContent = ({ data }) => {
  const Graph = data.graph;
  const budgetingDisabled = data.budgeting_disabled;
  return (
    <ContentBase style={{marginTop: -16}} padding="0">
      <BudgetDetails>
        <p><Price>{data.left}</Price> {budgetingDisabled ? "spent" : "left"}</p>
        <span className="muted">{!budgetingDisabled && "out of "}<Price>{data.total}</Price> {budgetingDisabled ? "spent last month" : "budgeted"}</span>
      </BudgetDetails>
      <div style={{padding: "10px 10px 0 10px", margin: "0 auto", textAlign: "center"}}>
        <Graph />
      </div>
    </ContentBase>
  )
}

export const RecurringsContent = ({ data }) => {
  const Graph = data.graph;
  return (
    <ContentBase>
      <RecurringLayout>
        <div className="graph">
          <Graph />
          <p><Price>{data.left}</Price></p>
          <span className="muted">left to pay</span>
        </div>
        {data.schedule.map((item, index) => {
        return (
          <LargeIconItem key={`recurring-${index}`}>
            <span className="emoji">{item.emoji}</span>
            <div>
              <RecurStatusRow>
                <div className={`recurring-item-${index}`}>{item.name}</div>
                <div><span className="muted">{item.date}</span><RecurringPaidSvg paid={item.paid} /></div>
              </RecurStatusRow>
              <span className="muted"><Price>{item.balance}</Price></span>
            </div>
          </LargeIconItem>
        )
      })}
      </RecurringLayout>
    </ContentBase>
  )
}

export const InvestmentsContent = ({ data }) => {
  const investments = data.length > 0;
  return (
    <ContentBase>
      <InvestmentLayout>
      {investments ? (
        data.map((brokerage, index) => {
        const BrokerIcon = brokerage.icon;
        return (
            <Brokerage key={`brokerage-${index}`}>
              <LargeIconItem>
                <BrokerIcon/>
                <div>
                  <div>{brokerage.name}</div>
                  <span className="muted"><Price>{brokerage.balance}</Price></span>
                </div>
              </LargeIconItem>
              <Pill key={index}>
                <ChangeAmount>{brokerage.performance}</ChangeAmount>
              </Pill>
            </Brokerage>
        )
      })) : (
        <Placeholder>
          <NoInvestmentsText/>
        </Placeholder>
      )}
      </InvestmentLayout>
    </ContentBase>
  )
}

const RecurStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 140px;
`

function RecurringPaidSvg({paid}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      fill="none"
      viewBox="0 0 15 14"
      style={{ marginBottom: -2, marginLeft: 16, opacity: paid ? 1 : 0 }}
    >
      <path
        fill="#0777E9"
        d="M6.156 13.354c.56 0 .991-.206 1.285-.643l6.317-9.516c.212-.314.3-.622.3-.909 0-.772-.608-1.353-1.408-1.353-.54 0-.888.198-1.223.717L6.129 9.963l-2.66-3.179c-.286-.342-.621-.499-1.08-.499-.806 0-1.394.581-1.394 1.367 0 .356.103.65.403.992l3.521 4.149c.335.39.731.56 1.237.56z"
      ></path>
    </svg>
  );
}


const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 44px 0;
`

export const Pill = styled.div`
    background: #032625;
    border-radius: 24px;
    padding: 2px 10px 4px 10px;
    margin: 0;
    text-align: center;
`
export const ChangeAmount = styled.div`    
    font-weight: 600;
    font-size: 0.92rem;
    line-height: 1.2;
    letter-spacing: -0.005em;
    color: #0AB101;
    &:before {
        content: url("data:image/svg+xml,%3Csvg width='9' height='10' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.28711 9.6377C4.55078 9.6377 4.76237 9.55306 4.92188 9.38379C5.08464 9.21452 5.16602 8.98991 5.16602 8.70996V4.36426L5.07324 2.33789L4.58984 2.72363L5.67871 4.05664L6.7041 5.0918C6.78548 5.17318 6.87663 5.24154 6.97754 5.29688C7.08171 5.35221 7.20215 5.37988 7.33887 5.37988C7.56999 5.37988 7.7653 5.30339 7.9248 5.15039C8.08431 4.99414 8.16406 4.78906 8.16406 4.53516C8.16406 4.30078 8.07292 4.09245 7.89062 3.91016L4.93164 0.946289C4.85677 0.871419 4.75911 0.811198 4.63867 0.765625C4.52148 0.720052 4.4043 0.697266 4.28711 0.697266C4.16992 0.697266 4.05273 0.720052 3.93555 0.765625C3.81836 0.811198 3.7207 0.871419 3.64258 0.946289L0.688477 3.91016C0.506185 4.09245 0.415039 4.30078 0.415039 4.53516C0.415039 4.78906 0.494792 4.99414 0.654297 5.15039C0.813802 5.30339 1.01074 5.37988 1.24512 5.37988C1.38184 5.37988 1.50065 5.35221 1.60156 5.29688C1.70247 5.24154 1.79199 5.17318 1.87012 5.0918L2.89551 4.05664L3.98438 2.72363L3.50098 2.33789L3.4082 4.36426V8.70996C3.4082 8.98991 3.48796 9.21452 3.64746 9.38379C3.81022 9.55306 4.02344 9.6377 4.28711 9.6377Z' fill='%2355B835'/%3E%3C/svg%3E%0A");
        width: 13.44px;
        height: 15.7px;
        scale: 0.4;
        margin-right: 4px;
    }
    &:after {
        content: "%";
    }
`

const InvestmentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`
const Brokerage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  & span.muted {
    font-size: 0.875rem;
    color: ${props => props.theme.color.textSecondary};
  }
`
const LargeIconItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  & span.emoji {
    text-align: left;
    margin: 0;
    font-size: 26px;
    margin-top: -6px;
  }
`

const RecurringLayout = styled.div`
  display: grid;
  grid-template-columns: 27% auto auto;
  grid-template-rows: 1fr 1fr;
  text-align: left;
  gap: 20px;
  color: ${props => props.theme.color.textPrimary};
  & span.muted {
    font-size: 0.875rem;
    color: ${props => props.theme.color.textSecondary};
  }
  & .graph {
    font-size: 1rem;
    display: none;
    margin: 0 auto;
    text-align: center;
    ${props => props.theme.device.laptopLg} {
      display: block;
      grid-area: 1 / 1 / span 2 / span 1;
    }
  }
`

const BudgetDetails = styled.div`
  margin: 0 auto;
  text-align: center;
  font-size: 1rem;
  color: ${props => props.theme.color.textPrimary};
  & span.muted {
    font-size: 0.875rem;
    color: ${props => props.theme.color.textSecondary};
  }
`

const Marker = styled.div`
  position: absolute;
  top: -53px;
  background-color: #334D6E;
  padding: 4px 6px;
  border-radius: 4px;
  left: 50%;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 0.75rem;
  z-index: 1;
  &:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 24px;
    width: 1px;
    height: 9999px;
    border-left: 2.5px dashed rgba(255,255,255,0.2);
  }
`
const TransactionRow = styled.li`
    text-decoration: none;
    display: grid;
    grid-template-columns: auto max-content;
    align-items: end;
    margin-bottom: 10px;
    padding-bottom: 16px;
`
const VenmoRow = styled.li`
  text-decoration: none;
  display: grid;
  grid-template-columns: 40% auto auto;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 4px;
  padding-top: 4px;
`
const Label = styled.span`
    height: 22px;
    font-style: normal;
    font-weight: 600;
    position: relative;
    overflow: hidden;
    &.large {
      font-size: 26px;
      line-height: 26px;
      height: 40px;
      margin-bottom: -18px;
    }
`
const Dots = styled.span`
    &:after {
        position: absolute;
        padding-left: .6ch;
        padding-right: .4ch;
        content: " . . . . . . . . . . . . . . . . . . . "
            ". . . . . . . . . . . . . . . . . . . . . . . "
            ". . . . . . . . . . . . . . . . . . . . . . . "
            ". . . . . . . . . . . . . . . . . . . . . . . "
            ". . . . . . . . . . . . . . . . . . . . . . . ";
        text-align: right;
        font-weight: 600;
        font-size: 30px; 
        margin-top: -21px;
        text-align: left;
        letter-spacing: -1px;
        background: ${props => `linear-gradient(90deg, ${props.theme.color.textSecondary} 3%, ${props.color} 100%)`};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
    }
`
const ContentBase = styled.div`
  padding: ${props => props.padding ? props.padding : "0 20px"};
  font-size: 0.875rem;
  font-weight: 600;
`
const PurchaseRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 16px 0;
`
const Product = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  & span:last-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 200px;
  }
  & span:first-child:after {
    content: "×";
    padding-left: 7px;
    color: ${props => props.theme.color.textSecondary};
  }
`
const Price = styled.span`
  &:before {
    content: "$";
    position: relative;
    font-size: 0.7rem;
    padding-right: 1px;
    vertical-align: top;
    top: 2px;
  }
`
export const Percent = styled.span`
  &:after {
    content: "%";
    position: relative;
    font-size: 0.7rem;
    font-weight: 800;
    padding-right: 1px;
    vertical-align: top;
    top: 1px;
  }
`

function NoInvestmentsText() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="93"
      height="11"
      fill="none"
      viewBox="0 0 93 11"
      style={{mixBlendMode: "screen", mixBlendMode: "plus-lighter"}}
    >
      <path
        fill="#5D7696"
        d="M.179 10H1.83l.868-7.056h.042L6.03 10h1.68L8.943.06H7.29L6.409 7.2l-.042.028L3.063.06H1.397L.179 10zM12.858 10.112c2.366 0 3.654-1.876 3.654-4.228 0-1.806-1.162-2.814-2.898-2.814-2.254 0-3.626 1.96-3.626 4.158 0 1.834 1.12 2.884 2.87 2.884zm.042-1.4c-.868 0-1.372-.714-1.372-1.666 0-1.288.784-2.576 1.988-2.576.588 0 1.442.28 1.442 1.554 0 1.484-.826 2.688-2.058 2.688zM22.448 2.132c.602 0 1.05-.448 1.05-1.036 0-.574-.434-.994-1.008-.994-.588 0-1.036.434-1.036 1.036 0 .56.42.994.994.994zM20.544 10h1.54l.84-6.832h-1.54L20.544 10zM24.125 10h1.54l.308-2.548c.224-1.708 1.512-2.996 2.352-2.996.672 0 .798.56.658 1.554L28.451 10h1.526l.56-4.116c.252-1.876-.238-2.814-1.694-2.814-.91 0-1.736.42-2.45 1.288l-.028-.014.14-1.176H24.98L24.125 10zM34.145 10.112c1.61 0 3.178-1.064 3.724-3.71.21-1.036.21-2.296.042-3.234h-1.568c.14.966.154 1.918-.014 2.828-.364 1.904-1.344 2.716-2.016 2.716-.63 0-.756-.546-.616-1.75l.476-3.794h-1.54l-.49 3.92c-.238 1.96.364 3.024 2.002 3.024zM41.814 8.698c-.602 0-1.176-.364-1.288-1.134 2.114-.238 4.242-.91 4.242-2.646 0-1.204-1.05-1.848-2.198-1.848-2.282 0-3.584 1.96-3.584 4.186 0 1.778 1.064 2.842 2.772 2.842 1.302 0 2.03-.462 2.814-1.26l-1.204-.868c-.49.504-.924.728-1.554.728zm.686-4.242c.462 0 .714.196.714.532 0 .826-1.274 1.19-2.618 1.344.294-1.316 1.19-1.876 1.904-1.876zM47.8 10.112c1.568 0 2.646-.756 2.632-2.198-.015-1.05-1.037-1.512-1.82-1.904-.617-.294-1.12-.588-1.12-.98s.322-.644.797-.644c.42 0 .966.182 1.372.686l1.023-1.036c-.616-.686-1.54-.966-2.38-.966-1.288 0-2.367.826-2.367 2.086 0 1.008.742 1.596 1.695 2.016.784.364 1.245.532 1.245.924 0 .434-.49.672-1.078.672-.56 0-1.105-.308-1.498-.826l-1.008.994c.477.714 1.498 1.176 2.507 1.176zM53.452 10.112a3.51 3.51 0 001.722-.476l-.21-1.344c-.378.224-.728.35-.98.35-.336 0-.532-.224-.462-.812l.42-3.36h1.666l.154-1.302h-1.666L54.39.732l-1.554.308-.28 2.128h-.728l-.154 1.302h.728l-.448 3.64c-.14 1.19.322 2.002 1.498 2.002zM56.419 10h1.54l.308-2.548c.224-1.708 1.512-2.996 2.212-2.996.546 0 .672.56.546 1.554L60.493 10h1.526l.35-2.646c.238-1.736 1.526-2.898 2.198-2.898.546 0 .672.56.546 1.554L64.567 10h1.54l.56-4.116c.252-1.876-.238-2.814-1.652-2.814-.924 0-1.722.406-2.394 1.246l-.056-.014c-.196-.826-.728-1.232-1.596-1.232-.784 0-1.582.406-2.268 1.246l-.042-.014.14-1.134h-1.526L56.419 10zM70.867 8.698c-.602 0-1.176-.364-1.288-1.134 2.114-.238 4.242-.91 4.242-2.646 0-1.204-1.05-1.848-2.198-1.848-2.282 0-3.584 1.96-3.584 4.186 0 1.778 1.064 2.842 2.772 2.842 1.302 0 2.03-.462 2.814-1.26l-1.204-.868c-.49.504-.924.728-1.554.728zm.686-4.242c.462 0 .714.196.714.532 0 .826-1.274 1.19-2.618 1.344.294-1.316 1.19-1.876 1.904-1.876zM74.752 10h1.54l.308-2.548c.224-1.708 1.512-2.996 2.352-2.996.672 0 .798.56.658 1.554L79.078 10h1.526l.56-4.116c.252-1.876-.238-2.814-1.694-2.814-.91 0-1.736.42-2.45 1.288l-.028-.014.14-1.176h-1.526L74.752 10zM84.31 10.112a3.51 3.51 0 001.721-.476l-.21-1.344c-.377.224-.727.35-.98.35-.335 0-.531-.224-.462-.812l.42-3.36h1.666l.154-1.302h-1.665l.294-2.436-1.555.308-.28 2.128h-.727L82.53 4.47h.728l-.448 3.64c-.14 1.19.322 2.002 1.498 2.002zM89.403 10.112c1.568 0 2.646-.756 2.632-2.198-.014-1.05-1.036-1.512-1.82-1.904-.616-.294-1.12-.588-1.12-.98s.322-.644.798-.644c.42 0 .966.182 1.372.686l1.022-1.036c-.616-.686-1.54-.966-2.38-.966-1.288 0-2.366.826-2.366 2.086 0 1.008.742 1.596 1.694 2.016.784.364 1.246.532 1.246.924 0 .434-.49.672-1.078.672-.56 0-1.106-.308-1.498-.826l-1.008.994c.476.714 1.498 1.176 2.506 1.176z"
      ></path>
    </svg>
  );
}

function NoIntegrationsText() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="93"
      height="13"
      fill="none"
      viewBox="0 0 93 13"
      style={{mixBlendMode: "screen", mixBlendMode: "plus-lighter"}}
    >
      <path
        fill="#5D7696"
        d="M.151 10h1.652l.868-7.056h.042L6.003 10h1.68L8.915.06H7.263L6.381 7.2l-.042.028L3.035.06H1.37L.151 10zM12.83 10.112c2.367 0 3.655-1.876 3.655-4.228 0-1.806-1.162-2.814-2.898-2.814-2.254 0-3.626 1.96-3.626 4.158 0 1.834 1.12 2.884 2.87 2.884zm.043-1.4c-.868 0-1.372-.714-1.372-1.666 0-1.288.784-2.576 1.988-2.576.588 0 1.442.28 1.442 1.554 0 1.484-.826 2.688-2.058 2.688zM22.42 2.132c.603 0 1.05-.448 1.05-1.036 0-.574-.433-.994-1.007-.994-.588 0-1.036.434-1.036 1.036 0 .56.42.994.994.994zM20.518 10h1.54l.84-6.832h-1.54L20.517 10zM24.098 10h1.54l.308-2.548c.224-1.708 1.512-2.996 2.352-2.996.672 0 .798.56.658 1.554L28.424 10h1.526l.56-4.116c.252-1.876-.238-2.814-1.694-2.814-.91 0-1.736.42-2.45 1.288l-.028-.014.14-1.176h-1.526L24.098 10zM33.655 10.112a3.51 3.51 0 001.722-.476l-.21-1.344c-.378.224-.728.35-.98.35-.336 0-.532-.224-.462-.812l.42-3.36h1.666l.154-1.302H34.3l.294-2.436-1.554.308-.28 2.128h-.728l-.154 1.302h.728l-.448 3.64c-.14 1.19.322 2.002 1.498 2.002zM39.12 8.698c-.601 0-1.175-.364-1.287-1.134 2.114-.238 4.242-.91 4.242-2.646 0-1.204-1.05-1.848-2.198-1.848-2.282 0-3.584 1.96-3.584 4.186 0 1.778 1.064 2.842 2.772 2.842 1.302 0 2.03-.462 2.814-1.26l-1.204-.868c-.49.504-.924.728-1.554.728zm.687-4.242c.462 0 .714.196.714.532 0 .826-1.274 1.19-2.618 1.344.294-1.316 1.19-1.876 1.904-1.876zM45.19 12.87c1.876 0 3.486-.672 3.864-3.724l.728-5.978h-1.526l-.07.532-.028.014c-.462-.448-1.12-.644-1.82-.644-2.044 0-3.346 2.114-3.346 4.046 0 1.526.714 2.772 2.338 2.772.756 0 1.596-.476 2.24-1.442l.028.014-.07.574c-.252 2.044-1.078 2.436-2.268 2.436-.714 0-1.288-.21-1.876-.588l-.504 1.33c.714.462 1.512.658 2.31.658zm.434-4.34c-.7 0-1.078-.546-1.078-1.386 0-1.162.7-2.674 1.918-2.674a2.3 2.3 0 011.54.644l-.07.462c-.266 1.764-1.4 2.954-2.31 2.954zM50.95 10h1.54l.308-2.562c.224-1.708 1.064-2.87 2.45-2.618l.21-1.75c-.826.014-1.61.448-2.254 1.344h-.028l.154-1.246h-1.526L50.95 10zM58.045 10.112c.714 0 1.54-.448 2.184-1.372l.042.014L60.117 10h1.526l.84-6.818h-1.526l-.07.532-.042.014c-.448-.462-1.092-.658-1.792-.658-2.044 0-3.36 2.114-3.36 4.27 0 1.526.728 2.772 2.352 2.772zm.294-1.358c-.714 0-1.092-.546-1.092-1.386 0-1.386.714-2.898 1.918-2.898.532 0 1.148.238 1.554.63l-.028.252c-.266 2.1-1.4 3.402-2.352 3.402zM65.374 10.112a3.51 3.51 0 001.722-.476l-.21-1.344c-.378.224-.728.35-.98.35-.336 0-.532-.224-.462-.812l.42-3.36h1.666l.154-1.302h-1.666l.294-2.436-1.554.308-.28 2.128h-.728l-.154 1.302h.728l-.448 3.64c-.14 1.19.322 2.002 1.498 2.002zM70.204 2.132c.602 0 1.05-.448 1.05-1.036 0-.574-.434-.994-1.008-.994-.588 0-1.036.434-1.036 1.036 0 .56.42.994.994.994zM68.3 10h1.54l.84-6.832h-1.54L68.3 10zM74.737 10.112c2.366 0 3.654-1.876 3.654-4.228 0-1.806-1.162-2.814-2.898-2.814-2.254 0-3.626 1.96-3.626 4.158 0 1.834 1.12 2.884 2.87 2.884zm.042-1.4c-.868 0-1.372-.714-1.372-1.666 0-1.288.784-2.576 1.988-2.576.588 0 1.442.28 1.442 1.554 0 1.484-.826 2.688-2.058 2.688zM79.551 10h1.54l.308-2.548c.224-1.708 1.512-2.996 2.352-2.996.672 0 .798.56.658 1.554L83.877 10h1.526l.56-4.116c.252-1.876-.238-2.814-1.694-2.814-.91 0-1.736.42-2.45 1.288l-.028-.014.14-1.176h-1.526L79.551 10zM89.43 10.112c1.568 0 2.646-.756 2.632-2.198-.014-1.05-1.036-1.512-1.82-1.904-.616-.294-1.12-.588-1.12-.98s.322-.644.798-.644c.42 0 .966.182 1.372.686l1.022-1.036c-.616-.686-1.54-.966-2.38-.966-1.288 0-2.366.826-2.366 2.086 0 1.008.742 1.596 1.694 2.016.784.364 1.246.532 1.246.924 0 .434-.49.672-1.078.672-.56 0-1.106-.308-1.498-.826l-1.008.994c.476.714 1.498 1.176 2.506 1.176z"
      ></path>
    </svg>
  );
}
